<template>
  <div class="customerBasicInfo">
    <QS-h4-title title="身份证" />
    <QS-column-box
      :source="source"
      :column="3"
      labelWidth="200"
      separator=":"
      :list="list"
    >
      <template slot="idCardUrl">
        <EnlargeImg :imgSrc="source.idCardUrl||''" class="avatar" />
      </template>
      <template slot="idCardBackUrl">
        <EnlargeImg :imgSrc="source.idCardBackUrl||''" class="avatar" />
      </template>
      <template slot="idCardValidDate">
        {{ longDate }}
      </template>
    </QS-column-box>
  </div>
</template>
<script>
import { longDateFormat } from '@/utils'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    longDate() {
      return longDateFormat('idCardValidDate', this.source)
    },
  },
}
</script>

<style lang="scss" scoped>
.customerBasicInfo{
  .positive{
    display: flex;
    width: 50%;
  }

  .reverse{
    display: flex;
    width: 50%;
  }

  span{
      text-align: right;
      padding-right: 10px;
      color: #333333;
      width: 150px;
    }
}
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
